export default function PHP_setcookie() {
  return (
    <div>
      <h1>PHP_setcookie</h1>
    </div>
  );
}
